import API from '@Services/apiAxios';
import { AISearchRequest, AISearchResult } from './types';

export function searchShipmentHistoryAI(req: AISearchRequest): Promise<AISearchResult> {
  return API.post('/shipment/ai-search', req).then(res => res.data);
}
